var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" Vue sample app ")]},proxy:true},{key:"footer",fn:function(){return [_vm._v(" © 2020 Some footer text ")]},proxy:true}])},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }